import { InfoOutlineIcon } from '@carboncopyco/icons';
import {
  ColorHex,
  TextBase,
  TextCaption,
  Tooltip,
  Typography,
} from '@carboncopyco/ui';
import { useRef } from 'react';
import { Link } from 'react-router-dom';

const message = 'Allow only business email domains';

type FilterEmailsLabelProps = { caption?: boolean };

export const FilterEmailsLabel = ({ caption }: FilterEmailsLabelProps) => {
  const filterEmailsRef = useRef<HTMLDivElement>();
  const textElement = caption ? (
    <TextCaption label={message} />
  ) : (
    <TextBase
      color="text-ds-natural-600"
      label={message}
    />
  );
  return (
    <div className="flex items-center gap-2">
      {textElement}
      <div ref={filterEmailsRef}>
        <InfoOutlineIcon
          size={16}
          color={ColorHex.natural}
        />
      </div>
      <Tooltip
        trigger="mouseenter"
        placement="top"
        anchorRef={filterEmailsRef}
        delay={[350, undefined]}
      >
        <div className="flex p-3">
          <Typography
            fontSize="text-ds-200"
            lineHeight="leading-ds-200"
            color="text-ds-natural"
            fontWeight="font-ds-normal"
            letterSpacing="tracking-ds-tight"
            label={
              <>
                Prevent access of users with non-work
                <br />
                email addresses, like Gmail, to ensure
                <br />
                security for your assets. View{' '}
                <Link
                  target="_blank"
                  referrerPolicy="no-referrer"
                  to="https://help.demostack.com/en/articles/8613132-how-to-enable-business-email-domain-restriction-for-your-demos-and-tours"
                >
                  <u>
                    the list
                    <br />
                    of blocked domains
                  </u>
                </Link>{' '}
                for more details.
              </>
            }
          />
        </div>
      </Tooltip>
    </div>
  );
};
